import { getDateStamps } from '../../lib/utils'

const state = {
  drafts: [],
}

const getters = {
  drafts: state => state.drafts,
  getDraft: state => id =>
    state.drafts.find(draft => draft.id === parseInt(id, 10)),
}

const mutations = {
  setDrafts(state, drafts) {
    console.debug('vuex.setDrafts', drafts)
    state.drafts = [].concat(drafts)
  },
  addDraft(state, draft) {
    console.debug('vuex.addDraft', draft)
    const dates = getDateStamps()
    state.drafts.push(Object.assign({}, draft, dates))
  },
  updateDraft(state, changes) {
    const i = state.drafts.findIndex(o => o.id === changes.id)
    console.debug('vuex.updateDraft', state.drafts[i], changes)
    const dates = getDateStamps(true)
    Object.assign(state.drafts[i], changes, dates)
  },
}

const actions = {}

export default {
  state,
  getters,
  mutations,
  actions,
}
